// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/add-tag-to-data-item-request-schema',
  type: 'object',
  required: ['id', 'tagId'],
  properties: {
    id: {
      type: 'integer',
    },
    tagId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
